/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Names are omitted when the caller has no access to the referral's facility.
 * @export
 * @interface InboundDocumentLead
 */
export interface InboundDocumentLead {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    is_deleted: boolean;
}

/**
 * Check if a given object implements the InboundDocumentLead interface.
 */
export function instanceOfInboundDocumentLead(value: object): value is InboundDocumentLead {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('is_deleted' in value) || value['is_deleted'] === undefined) return false;
    return true;
}

export function InboundDocumentLeadFromJSON(json: any): InboundDocumentLead {
    return InboundDocumentLeadFromJSONTyped(json, false);
}

export function InboundDocumentLeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentLead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'facility_id': json['facility_id'],
        'is_deleted': json['is_deleted'],
    };
}

export function InboundDocumentLeadToJSON(json: any): InboundDocumentLead {
    return InboundDocumentLeadToJSONTyped(json, false);
}

export function InboundDocumentLeadToJSONTyped(value?: InboundDocumentLead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'facility_id': value['facility_id'],
        'is_deleted': value['is_deleted'],
    };
}

